import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { accountListReq } from "../../apis/accountsApi";

// Define the async thunk for account list
export const accountList = createAsyncThunk(
  "accounts/fetchAccountList",
  async ({ idToken, params }, { rejectWithValue }) => {
    try {
      const response = await accountListReq(idToken, params);
      return response; // Assuming accountListReq returns an object with data property
    } catch (error) {
      return rejectWithValue(error.response.data); // Return specific error data from API
    }
  }
);

const accountSlice = createSlice({
  name: "accounts",
  initialState: {
    isLoading: false,
    isError: false,
    data: [],
    login_id: null,
  },
  reducers: {
    resetAccount: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.data = [];
      state.login_id = null;
    },
    setDefaultLoginId: (state, action) => {
      state.login_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(accountList.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(accountList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload; // Update state with fetched data
      })
      .addCase(accountList.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

// Export the async thunk and any reducers if needed
export const { resetAccount, setDefaultLoginId } = accountSlice.actions;
export default accountSlice.reducer;
